import Vue from 'vue';
import Router from 'vue-router';
import customer from './modules/oa-customer';
import approval from './modules/oa-approval';
import company from './modules/company';
import oaPrint from './modules/print';

Vue.use(Router);

/**
 * 未登录可访问的路由
 */
const constantRouterMap = [
  {
    name: 'refresh',
    path: '/refresh',
    component: () => import('@/views/component/refresh/index.vue')
  },
  {
    name: 'login',
    path: '/login',
    component: () => import('@/views/account/login.vue')
  },
  {
    name: 'test',
    path: '/test',
    component: () => import('@/views/account/test.vue')
  },
  {
    name: 'logined',
    path: '/logined',
    component: () => import('@/views/account/logined.vue')
  },
  {
    name: '404',
    path: '/404',
    component: () => import('@/views/errPage/404.vue')
  }
];

/**
 * 登录后注册的路由
 */
const asyncRouterMap = [
  customer,
  approval,
  company,
  ...oaPrint,
  {
    path: '',
    redirect: '/approval'
  },
  {
    path: '*',
    redirect: '/404',
    meta: {
      title: '404',
    }
  }
];

export {
  constantRouterMap,
  asyncRouterMap
};

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
});
